import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DxFileUploaderModule } from "devextreme-angular";

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { LoginComponent } from './account/auth/login/login.component';
import { NoAuthGuard } from './core/guards/no-auth.guard';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Page404Component } from './extrapages/page404/page404.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'login', canActivate: [NoAuthGuard], component: LoginComponent },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  { path: '**', component: Page404Component }
];


@NgModule({
  imports: [DxFileUploaderModule, RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})

export class AppRoutingModule { }
